import { APP_CONFIG }  from '@appConfig/_app-config_master';
import { ActiveForms } from '@core/interfaces/form.interface';
import { IMedia }      from '@core/interfaces/media-interfaces';
import {
	createFeatureSelector,
	createSelector,
	MemoizedSelector
}                      from '@ngrx/store';
import {
	IPageLoader,
	State
}                      from './state';

const getActiveForms = ( state: State ): ActiveForms => state.activeForms;
const getCompactNavMenu = ( state: State ): boolean => state.compactNavMenu;
const getCurrentUiEvent = ( state: State ): { eventName: string; data: any } => state.currentUiEvent;
const getError = ( state: State ): any => state.error;
const getLanguage = ( state: State ): string => state.language;
const getMediaData = ( state: State ): IMedia => state.media;
const getPageLoader = ( state: State ): IPageLoader => state.pageLoader;
const getPageLoaderVisibility = ( state: State ): boolean => state.pageLoader.show;


export const selectUiState: MemoizedSelector<object, State> = createFeatureSelector<State>( APP_CONFIG.ui.store.id );

export const selectActiveForms: MemoizedSelector<object, ActiveForms> = createSelector( selectUiState, getActiveForms );

export const selectCompactNavMenu: MemoizedSelector<object, boolean> = createSelector( selectUiState, getCompactNavMenu );

export const selectCurrentUiEvent: MemoizedSelector<object, { eventName: string; data: any }> = createSelector( selectUiState, getCurrentUiEvent );

export const selectLanguage: MemoizedSelector<object, string> = createSelector( selectUiState, getLanguage );

export const selectMediaData: MemoizedSelector<object, IMedia> = createSelector( selectUiState, getMediaData );

export const selectPageLoader: MemoizedSelector<object, IPageLoader> = createSelector( selectUiState, getPageLoader );

export const selectPageLoaderVisibility: MemoizedSelector<object, boolean> = createSelector( selectUiState, getPageLoaderVisibility );

export const selectUiError: MemoizedSelector<object, any> = createSelector( selectUiState, getError );
